import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GroupIcon(props: IconProps) {
    return <Icon {...props} iconKey={"group"}/>
}
